import state from './admin-role.state.js'
import mutations from './admin-role.mutations.js'
import actions from './admin-role.actions.js'
import getters from './admin-role.getters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

